import domReady from '@wordpress/dom-ready';

domReady(() => {
  const stickyLimit = 40;
  let sticky = 40;
  let timer = null;
  const logo = document.querySelector('.navbar__logo');

  function updateLogo() {
    if (document.body.classList.contains('mobile-menu-open')) {
      logo.src = '/wp-content/themes/restauration.org/assets/images/logo.svg';
    } else {
      const st = window.scrollY;
      if (st <= stickyLimit) {
        logo.src =
          '/wp-content/themes/restauration.org/assets/images/logo_blanc.svg';
      } else {
        logo.src = '/wp-content/themes/restauration.org/assets/images/logo.svg';
      }
    }
  }

  function stickyNavbar() {
    const st = window.scrollY;
    if (st >= sticky) {
      document.body.classList.add('sticky-navbar');
    } else {
      document.body.classList.remove('sticky-navbar');
    }

    if (document.body.classList.contains('home')) {
      if (st <= stickyLimit) {
        document.body.classList.add('transparent-navbar');
      } else {
        document.body.classList.remove('transparent-navbar');
      }
    }

    sticky = st + 40;

    if (document.body.classList.contains('home')) {
      updateLogo();
    }
  }

  window.addEventListener('scroll', () => {
    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
      // actual callback
      stickyNavbar();
    }, 50);
  });

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName === 'class') {
        // Appeler updateLogo uniquement sur la page d'accueil
        if (document.body.classList.contains('home')) {
          updateLogo();
        }
      }
    });
  });

  observer.observe(document.body, { attributes: true });

  stickyNavbar();

  if (document.body.classList.contains('transparent-navbar')) {
    logo.src =
      '/wp-content/themes/restauration.org/assets/images/logo_blanc.svg';
  }
});
